import React from 'react';
import { node, object, bool } from 'prop-types';

import { InfoWindow } from 'google-maps-react';

import './MapTooltip.css';

const MapTooltip = ({
    marker,
    visible,
    children,
    infoWindowRef,
    ...rest
  }) => {
  return (
    <InfoWindow
      marker={marker}
      visible={visible}
      ref={infoWindowRef}
      {...rest}
    >
      <div className={'tooltip'}>
        <div className={'innerBlock'}>
          {children}
        </div>
      </div>
    </InfoWindow>
  );
};

MapTooltip.propTypes = {
  children: node,
  marker: object,
  visible: bool,
  infoWindowRef: object
};

MapTooltip.displayName = 'MapTooltip';

export default MapTooltip;


// WEBPACK FOOTER //
// ./src/uis/components/Map/MapTooltip/MapTooltip.js